import { Button, Card, Col, Drawer, Form, Icon, Row, message, Tooltip } from 'antd';
import React, { Component } from 'react';
import PropTypes from "prop-types";
import { ADD_NEW_PROGRAM_FIELDS } from "constants/form-fields";

import {
    fieldGenerator,
    getErrorOnField,
    getValidateStatus
} from "utilities/form";
import { CompanyService } from '../../services';

class AddNewProgram extends React.Component {
    fieldGenerator = fieldGenerator.bind(this.props.form);
    getErrorOnField = getErrorOnField.bind(this.props.form);
    getValidateStatus = getValidateStatus.bind(this.props.form);

    state = {
        addProgramLoader: false
    }

    onSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.addNewProgram(values)
            }
        });

    }


    addNewProgram = (values) => {
        const data = {...values, "company_id" : this.props.companyId};
        this.setState({
            addProgramLoader: true
        })
        CompanyService.addNewProgram(data)
            .then((resp) => {
                message.success("Program Created Successfully");
                this.props.onClose();
                this.props.fetchCompanyMpa();
                this.setState({
                    addProgramLoader: false
                })
            })
            .catch((err) => {
                this.props.form.resetFields()
                if (err.non_field_errors) {
                    message.error(err.non_field_errors[0]);
                } else {
                    message.error("Something went wrong!");
                }
                this.setState({
                    addProgramLoader: false
                })
                this.props.onClose();
            })
    }
    render() {
        return (
            <Drawer
                title={"Add New Program"}
                closable
                visible={this.props.visible}
                onClose={this.props.onClose}
                placement={"right"}
                width={"30vw"}
                footer={null}
            >
                <Row className='form'>
                    <Form>
                        {ADD_NEW_PROGRAM_FIELDS.map((field, fieldName) => {
                            if(field.tooltip){
                                field.label = <Tooltip title={field.tooltip}>{field.label}</Tooltip>
                            }
                            return <Row>{this.fieldGenerator(
                                fieldName,
                                field,
                                this.getValidateStatus(fieldName),
                            )()}</Row>
                        }).toList()}
                        <Col span="24" className={"p-10"}>
                            <Button type='primary' loading={this.state.addProgramLoader} className={"mr-5"} onClick={this.onSubmit}>
                                Submit
                            </Button>
                        </Col>
                    </Form>
                </Row>
            </Drawer>
        )
    }
}

AddNewProgram.propTypes = {
    visible: PropTypes.bool,
    onClose: PropTypes.func,
    createNewProgram: PropTypes.func,
    loading: PropTypes.bool
};


export default Form.create({})(AddNewProgram);